export default __webpack_public_path__ + "static/media/spoolSheets2.25034dcd.jpg";